/** 认证类型 */
export enum AuthTypeEnum {
  /** 谷歌验证 */
  GOOGLE_CAPTCHA = 1,
  /** 双因素认证 */
  TWO_FACTOR_AUTH = 2,
  /** 双因素 - 备份码 */
  TWO_FACTOR_BACKUP_CODE = 3,
}

/** 谷歌版本 */
export enum GoogleCaptchaVersionEnum {
  V2 = 'v2',
  V3 = 'v3',
}

/** 验证码表单 类型声明 */
export type CaptchaFormDataType = {
  /** 谷歌token */
  captchaToken?: string;
  /** 动态码 */
  code?: number;
  /** 备份码 */
  backupCode?: string;
  /** 验证类型 */
  authType: AuthTypeEnum;
  /** 谷歌版本 */
  recaptchaVersion?: GoogleCaptchaVersionEnum;
};
